import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Configuration } from '../utilities/configuration';
import { Observable, throwError } from 'rxjs';
import { catchError, distinctUntilChanged, map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})

export class DataService {
    private baseServerURL: string;

    constructor(private http: HttpClient,
        public _configuration: Configuration
    ) {
        this.baseServerURL = _configuration.baseServerURL;
    }

    handleError(error: Response) {
        return throwError(error.statusText || "Eerver error.");
    }

    public get<T>(actionurl: any, param?: any): Observable<T> {
        const endpointurl: string = this.baseServerURL + actionurl;
        return this.http.get<T>(endpointurl, { params: param })
            .pipe(
                map((response: T) => { return response; }),
                catchError(this.handleError)
            );
    }

    public getByPost<T>(actionUrl: any, params: any): Observable<T> {
        const endpointurl: string = this.baseServerURL + actionUrl;
        return this.http.post<T>(endpointurl, params)
            .pipe(
                map((response: T) => {
                    return response;
                }),
                catchError(this.handleError)
            );
    }

    public post<T>(actionUrl: any, object: any): Observable<T> {
        const endpointurl: string = this.baseServerURL + actionUrl;
        return this.http.post<T>(endpointurl, object)
            .pipe(
                map((response: T) => { return response; }),
                catchError(this.handleError)
            );
    }

    public externalPost<T>(endpointurl: any, object: any): Observable<T> {
        return this.http.post<T>(endpointurl, object)
            .pipe(
                map((response: T) => { return response; }),
                catchError(this.handleError)
            );
    }

    public search<T>(actionurl: any, param?: any): Observable<T> {
        const endpointurl: string = this.baseServerURL + `${actionurl}=${param}`;
        return this.http.get<T>(endpointurl)
            .pipe(
                distinctUntilChanged(),
                // debounceTime(1000),
                map((response: T) => { return response; }),
                catchError(this.handleError)
            );
    }
}
